import { Component, OnInit, HostBinding } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AreaParticipacaoService } from 'src/app/Services/area-participacao.service';
import { AreaParticipacao } from 'src/app/Models/area-participacao.mode';
import { opacityAnimation } from 'src/app/Animations/opacity.animation';
import { ActivatedRoute, Router } from '@angular/router';
import { Pergunta } from 'src/app/Models/pergunta.model';
import { forkJoin } from 'rxjs';
import { PerguntaService } from 'src/app/Services/pergunta.service';
import { Alternativa } from 'src/app/Models/alternativa.model';
import { Resposta } from 'src/app/Models/resposta.model';
import { map } from 'rxjs/operators';
import { AlternativaService } from 'src/app/Services/alternativa.service';
import { RespostaService } from 'src/app/Services/resposta.service';
import { LocationStrategy } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/components/common/messageservice';
import { FormGroup, FormBuilder } from '@angular/forms';
import { RespostaWebAPI } from '../../../Models/resposta-web-api.model';
import { ToastrService } from 'ngx-toastr';
import { UserToken } from 'src/app/Models/token.model';
import { Sugestao } from 'src/app/Models/sugestao.model';
import { SugestaoService } from 'src/app/Services/sugestao.service';

@Component({
  selector: 'ppa-questionario',
  templateUrl: './questionario.component.html',
  styleUrls: ['./questionario.component.css'],
  animations: [opacityAnimation]
})
export class QuestionarioComponent implements OnInit {

  @HostBinding('@load')

  @BlockUI('quesionario') blockUI: NgBlockUI;

  formQuestionario: FormGroup;
  areaParticipacao: AreaParticipacao;
  private perguntaId: number = 0;
  private IDsperguntas: number[];
  private areaParticipacaoId: number;
  numeroPergunta: number = 0;
  listaPerguntaId: number[];
  pergunta: Pergunta;
  alternativas: Alternativa[];
  resposta: Resposta = null;
  primeira: boolean = false;
  ultima: boolean = false;
  exibirSugestao: boolean = false;
  AlternativaSelecionada: number = 0;
  usuarioLogado: UserToken = null;
  sugestao: string = null;
  possuiResposta: boolean = false;
  possuiSugestao: boolean = false;

  constructor(private areaParticipacaoService: AreaParticipacaoService,
    private rotaSnapshot: ActivatedRoute,
    private rota: Router,
    private perguntaService: PerguntaService,
    private alternativaService: AlternativaService,
    private respostaService: RespostaService,
    private sugestaoService: SugestaoService,
    private locationStrategy: LocationStrategy,
    private toast: ToastrService,
    private formBuilder: FormBuilder,
    ) {
      
      this.areaParticipacaoId = this.rotaSnapshot.snapshot.params['areaParticipacaoId'];
      if (this.rotaSnapshot.snapshot.params['perguntaId'] != undefined)
        this.perguntaId = this.rotaSnapshot.snapshot.params['perguntaId'];

      if (this.rotaSnapshot.snapshot.params['Ids'] != undefined){
        this.IDsperguntas = this.rotaSnapshot.snapshot.params['Ids'].split(",");
        this.perguntaId = this.IDsperguntas[0];
      }
  }

  ngOnInit() {
    this.usuarioLogado = JSON.parse(sessionStorage.getItem('usuariologado'));
    this.blockUI.start('Aguarde...');
    this.carregarAreaParticipacao(this.areaParticipacaoId);
    this.perguntaService.obterPerguntasId(this.areaParticipacaoId)
      .subscribe(response => {
        this.listaPerguntaId = response
        this.carregarPergunta('inicio');
        this.primeira = true;
      });

    this.inicializarForm();
  }

  carregarPergunta(funcao) {

    this.primeira = false;
    this.ultima = false;
    this.exibirSugestao = false;

    if ((funcao == 'proximo') && this.AlternativaSelecionada == 0){
      this.toast.error('Selecione uma das alternativas.', 'Atenção', { enableHtml: true });
    }
    else{
      if (funcao == 'inicio' || funcao == 'proximo'){

        if (this.numeroPergunta < this.IDsperguntas.length){
          
          if (funcao == 'proximo'){
              this.SalvarRespostaBancoDados();
          }

          this.perguntaId = this.IDsperguntas[this.numeroPergunta];
          this.numeroPergunta = this.numeroPergunta + 1;
          this.montarQuestionario(this.perguntaId);
        }
        else if(this.numeroPergunta == this.IDsperguntas.length){
          if (funcao == 'proximo'){
            this.SalvarRespostaBancoDados();
            this.numeroPergunta = this.numeroPergunta + 1;
          }
          this.ultima = true;
          this.exibirSugestao = true;
        }
      }
      else if (funcao == 'anterior'){
        this.numeroPergunta = this.numeroPergunta - 1;
        if ((this.numeroPergunta - 1) < this.IDsperguntas.length){
          this.perguntaId = this.IDsperguntas[this.numeroPergunta - 1];
          this.pergunta = null;
          this.alternativas = null;
          this.montarQuestionario(this.perguntaId);
          
        }
      }
      else if (funcao == 'finalizar'){

        if (this.sugestao == null || this.sugestao == ''){
          if(!confirm("Você não informou nenhuma sugestão \ndeseja finalizar mesmo assim?")){
            this.exibirSugestao = true;
            return false;
          }
        }

        //this.SalvarRespostaBancoDados();
        if ((this.sugestao != null && this.sugestao != '') && !this.possuiSugestao){
          this.salvarSugestao();
          this.toast.success('Pesquisa realizada com sucesso.', 'Mensagem', { enableHtml: true });
        }
        this.sair();
      }

      if (this.numeroPergunta == this.IDsperguntas.length){
        if (this.numeroPergunta == 1 && !this.exibirSugestao)
          this.primeira = true;
        
        this.possuiSugestao = false;
        this.sugestaoService.getByAreaParticipante(this.areaParticipacaoId, this.usuarioLogado.usuario_id)
        .subscribe((resposta: RespostaWebAPI) => {
          this.sugestao = resposta.data[0].descricao == null ? '' : resposta.data[0].descricao;
          if(this.sugestao != ''){this.possuiSugestao = true;}
        }, (erroResponse: HttpErrorResponse) => {
          this.toast.error(erroResponse.error.message, 'Atenção', { enableHtml: true });
          this.blockUI.stop();
        },
        ()=> {

        });
      }
      else{
        if (this.numeroPergunta == 1)
          this.primeira = true;
      }
    }
  }

  SalvarRespostaBancoDados(){

    if (this.possuiResposta){
      return;
    }

    this.blockUI.start('Aguarde...');
    var resposta: Resposta = new Resposta();
    resposta.alternativaid = this.AlternativaSelecionada;
    resposta.participanteid = this.usuarioLogado.usuario_id;
    resposta.perguntaid = this.perguntaId;
    this.respostaService.post(resposta)
    .subscribe(() => {
      
    }, (erroResponse: HttpErrorResponse) => {
      this.toast.error(erroResponse.error.message, 'Atenção', { enableHtml: true });
      this.blockUI.stop();
    },
    ()=> {
      setTimeout(() => {
        this.blockUI.stop();
        this.toast.success('Resposta salva com sucesso.', 'Atenção', { enableHtml: true });
      }, 2000);
    });

    this.AlternativaSelecionada = 0;
    this.pergunta = null;
    this.alternativas = null;
  }

  salvarSugestao(){

    var sugestao: Sugestao = new Sugestao();
    sugestao.areaparticipacaoid = this.areaParticipacaoId;
    sugestao.descricao = this.sugestao;
    sugestao.enqueteid = 1;
    sugestao.participanteid = this.usuarioLogado.usuario_id;

    this.sugestaoService.post(sugestao).subscribe(() => {
      
    }, (erroResponse: HttpErrorResponse) => {
      this.toast.error(erroResponse.error.message, 'Atenção', { enableHtml: true });
      this.blockUI.stop();
    },
    ()=> {
      setTimeout(() => {
        this.blockUI.stop();
        this.toast.success('Sugestão salva com sucesso.', 'Atenção', { enableHtml: true });
      }, 2000);
    });
  }

  sair() {
    this.numeroPergunta = 0;
    this.AlternativaSelecionada = 0;
    this.pergunta = null;
    this.alternativas = null;
    this.rota.navigate(['participante']);
  }

  //Ajustar conforme get/post da api.
  private inicializarForm() {
    this.formQuestionario = this.formBuilder.group({});
  }

  private carregarAreaParticipacao(areaParticipacaoId: number) {
    this.areaParticipacaoService
      .getAreaParticipacao(areaParticipacaoId)
      .subscribe(response => {
        this.areaParticipacao = response;
      },
        (erro: HttpErrorResponse) => {
          this.toast.error(erro.message, 'Erro', { enableHtml: true });
        });
  }

  private montarQuestionario(perguntaId: number) {
    var pergunta: RespostaWebAPI;
    var respostawebapi: RespostaWebAPI;
    this.pergunta = null;
    this.alternativas = null;
    this.resposta = null;
    this.possuiResposta = false;
    forkJoin(
      this.perguntaService.obterPerguntaId(perguntaId).pipe(map((resp : RespostaWebAPI) => {pergunta = resp; })),
      this.respostaService.getPorParticipante(this.usuarioLogado.usuario_id, perguntaId).pipe(map((resp : RespostaWebAPI) => {respostawebapi = resp; })),
    ).subscribe(() => {
    }, null, () => {
      this.pergunta = pergunta.data[0];
      this.alternativas = this.pergunta.alternativa;
      this.resposta = respostawebapi.data[0];

      // pergunta já respondida pelo participante
      if (this.resposta.respostaid > 0){
        this.possuiResposta = true;
        this.AlternativaSelecionada = this.resposta.alternativaid;
      }
      else
        this.AlternativaSelecionada = 0;
      
        this.blockUI.stop()
    });
  }
}
